import React from 'react'
import { addSeparators } from 'utils'
import { DiscountCode } from 'discounts/types'
import { useTranslation } from 'translations'

interface UsageCountProps {
    usage?: DiscountCode['usage']
}

export const UsageCount: React.FC<UsageCountProps> = ({ usage }) => {
    const { t } = useTranslation()

    if (!usage) {
        return <>{t('discounts.shared.unlimited')}</>
    }

    return (
        <>
            {addSeparators(usage.used)}/{addSeparators(usage.total)}
        </>
    )
}
